import request from "@/utils/request";
const UserAuthLoginUrl = `${process.env.VUE_APP_AGENT_SERVICE}/api/v1/agent/auth`;
const customerUrl = `${process.env.VUE_APP_AGENT_SERVICE}/api/v1/agent/customer`;
const BuscustomerUrl = `${process.env.VUE_APP_AGENT_SERVICE}/api/v1/agent/business`;
const beneficiaryUrl = `${process.env.VUE_APP_AGENT_SERVICE}/api/v1/agent/beneficiary`;
const paymentUrl = `${process.env.VUE_APP_AGENT_SERVICE}/api/v1/agent/payment`;
const dashboardUrl = `${process.env.VUE_APP_AGENT_SERVICE}/api/v1/agent/dashboard`;
export default {
  // --------------------------------------AUTHENTICATION MODULE----------------------------------//
  Login(userCredentials) {
    return request({
      url: `${UserAuthLoginUrl}/login`,
      method: "POST",
      data: userCredentials,
    });
  },
  Createpassword(data) {
    return request({
      url: `${UserAuthLoginUrl}/forget-password`,
      method: "POST",
      data,
    });
  },
  verifyOTP(data) {
    return request({
      url: `${UserAuthLoginUrl}/two-step-auth/confirm-otp`,
      method: "POST",
      data,
    });
  },

  getOTP(user_email) {
    return request({
      url: `${UserAuthLoginUrl}/two-step-auth/get-otp?user_email=${user_email}`,
      method: "GET",
    });
  },
  Logout() {
    return request({
      url: `${UserAuthLoginUrl}/logout`,
      method: "GET",
    });
  },
  //---------------------Create Individual Customer---------------------//
  addIndCustomer(data) {
    return request({
      url: `${customerUrl}/add`,
      method: "POST",
      data,
    });
  },
  uploadCustDocs(value, value_code, data) {
    return request({
      url: `${customerUrl}/upload-document?login_id=${value}&doc_type=${value_code}`,
      method: "POST",
      data,
    });
  },
  getCustomerList(params) {
    return request({
      url: `${customerUrl}/filter-list`,
      method: "POST",
      data: params,
    });
  },
  getReferralName(code) {
    return request({
      url: `${customerUrl}/check-sp-reference-code?sp_reference_code=${code}`,
      method: "GET",
    });
  },
  //-------------------------Create Business Customer-------------------------------//
  addEntityinformation(data, params) {
    return request({
      url: `${BuscustomerUrl}/entity-information`,
      method: "POST",
      data,
      params: params,
    });
  },
  updateEntityinformation(data, params) {
    return request({
      url: `${BuscustomerUrl}/update-entity-information`,
      method: "PUT",
      data,
      params: params,
    });
  },
  getEntityinformation(params) {
    return request({
      url: `${BuscustomerUrl}/get-entity-information`,
      method: "GET",
      params: params,
    });
  },
  getOthersData(params) {
    return request({
      url: `${BuscustomerUrl}/get-other-data`,
      method: "GET",
      params: params,
    });
  },
  addOtherData(data, params) {
    return request({
      url: `${BuscustomerUrl}/add-other-data`,
      method: "POST",
      data,
      params: params,
    });
  },
  getUploadBusDocs(params) {
    return request({
      url: `${BuscustomerUrl}/get-upload-documents`,
      method: "GET",
      params: params,
    });
  },
  UploadBusDocs(data, params) {
    return request({
      url: `${BuscustomerUrl}/upload-documents`,
      method: "POST",
      data,
      params: params,
    });
  },
  getOnboardingStatus(params) {
    return request({
      url: `${BuscustomerUrl}/get-onboarding-status`,
      method: "GET",
      params,
    });
  },
  getDeclarationData(params) {
    return request({
      url: `${BuscustomerUrl}/get-business-declaration`,
      method: "GET",
      params: params,
    });
  },
  addDeclarationData(data, params) {
    return request({
      url: `${BuscustomerUrl}/add-business-declaration`,
      method: "POST",
      data,
      params: params,
    });
  },
  getApplicantInfo(params) {
    return request({
      url: `${BuscustomerUrl}/get-applicant-information-data`,
      method: "GET",
      params: params,
    });
  },
  addApplicantInfo(data, params) {
    return request({
      url: `${BuscustomerUrl}/add-applicant-information`,
      method: "POST",
      data,
      params: params,
    });
  },
  updateApplicantInfo(data, params) {
    return request({
      url: `${BuscustomerUrl}/update-applicant-information`,
      method: "PUT",
      data,
      params: params,
    });
  },
  UploadApplicantFiles(data, params) {
    return request({
      url: `${BuscustomerUrl}/applicant-information/upload-docs`,
      method: "POST",
      data,
      params: params,
    });
  },
  deleteApplicantInfo(params) {
    return request({
      url: `${BuscustomerUrl}/delete-applicant-information`,
      method: "DELETE",
      params,
    });
  },
  getAllApplicantsinfo(params) {
    return request({
      url: `${BuscustomerUrl}/all-applicant-information`,
      method: "GET",
      params: params,
    });
  },
  addAuthorizedIndInfo(data, params) {
    return request({
      url: `${BuscustomerUrl}/add-authorization-ind-person-information`,
      method: "POST",
      data,
      params: params,
    });
  },
  updateAuthorizedIndInfo(data, params) {
    return request({
      url: `${BuscustomerUrl}/update-authorization-ind-person-information`,
      method: "PUT",
      data,
      params: params,
    });
  },
  addAuthorizedBusInfo(data, params) {
    return request({
      url: `${BuscustomerUrl}/add-authorization-bus-person-information`,
      method: "POST",
      data,
      params: params,
    });
  },
  updateAuthorizedBusInfo(data, params) {
    return request({
      url: `${BuscustomerUrl}/update-authorization-bus-person-information`,
      method: "PUT",
      data,
      params: params,
    });
  },
  //------------------------Beneficiary Summary ---------------------------------//
  getremitteeList(cust_id) {
    return request({
      url: `${beneficiaryUrl}/get-list?customer_id=${cust_id}`,
      method: "GET",
    });
  },
  createIndBene(cust_id, data) {
    return request({
      url: `${beneficiaryUrl}/add?customer_id=${cust_id}`,
      method: "Post",
      data,
    });
  },
  deleteBene(bene_id) {
    return request({
      url: `${beneficiaryUrl}/delete?receiver_id=${bene_id}`,
      method: "delete",
    });
  },
  getremitteeListByCntry(params) {
    return request({
      url: `${beneficiaryUrl}/get-by-country`,
      method: "GET",
      params: params,
    });
  },

  //-----------------------Dashboard page----------------------------//
  getHoldTxnHome(params) {
    return request({
      url: `${dashboardUrl}/no-hold-txns`,
      method: "GET",
      params: params,
    });
  },
  getDashboardTxns(params) {
    return request({
      url: `${dashboardUrl}/no-all-txns`,
      method: "POST",
      params: params,
    });
  },
  //-----------------------Hold Transactions page----------------------------//
  getHoldTxnByDate(params) {
    return request({
      url: `${dashboardUrl}/get-txns-by-date`,
      method: "POST",
      params: params,
    });
  },
  getHoldTxnSummary(params) {
    return request({
      url: `${dashboardUrl}/txn-summery`,
      method: "GET",
      params: params,
    });
  },
  getHoldTxnDetails(txn_id) {
    return request({
      url: `${dashboardUrl}/get-txn-details?txn_id=${txn_id}`,
      method: "GET",
    });
  },
  updateHoldtxn(params) {
    return request({
      url: `${paymentUrl}/approve`,
      method: "PUT",
      params: params,
    });
  },
  //------------------------Send Money---------------------------------//

  makePayment(login_id, data) {
    return request({
      url: `${paymentUrl}/do?login_id=${login_id}`,
      method: "Post",
      data,
    });
  },
  uploadIdfirstPage(params, data) {
    return request({
      url: `${paymentUrl}/upload-onbehalf-document`,
      method: "Post",
      params: params,
      data,
    });
  },
};
